import {
  aMap,
  location,
  SearchCity,
  getCityconvertFrom,
  LocalCity
} from '@/utils/aMap'
import { Taost } from 'vant'

const setDeafultLocal = ({ commit, state }) => {
  state.locationInfo.lat = 23.12463
  state.locationInfo.lng = 113.36199
  state.locationInfo.city = '广州市'
  state.locationInfo.province = '广东省'
}

// 获取定位信息
const getLocation = ({ commit, state }) => {
  return new Promise(async (resolve, reject) => {
    console.log('getLocation', await location())
    try {
      const AMapLocation = await location().catch(err => {
        console.error(err, '初始化定位失败')
        // 初始化失败时直接使用默认位置
        setDeafultLocal({ commit, state })
        resolve({
          status: true,
          data: {},
          message: '使用默认位置'
        })
        return null
      })
      // 如果初始化失败，直接返回
      if (!AMapLocation) return

      // 设置更合理的超时处理
      // const timeoutPromise = new Promise((_, reject) => {
      //   setTimeout(() => {
      //     console.warn('定位超时，使用默认位置')
      //     setDeafultLocal({ commit, state })
      //     resolve({
      //       status: true,
      //       data: {},
      //       message: '定位超时，使用默认位置'
      //     })
      //   }, 10000)
      // })

      await AMapLocation.getCurrentPosition(
        async (status, result) => {
          console.log(
            status,
            result,
            '定位结果getCurrentPosition'
          )

          // 情况1：定位完全失败，尝试通过IP获取城市信息
          if (status !== 'complete') {
            console.warn('定位失败，尝试通过IP获取位置')
            AMapLocation.getCityInfo(
              (cityStatus, cityResult) => {
                console.log(
                  cityStatus,
                  cityResult,
                  'getCityInfo'
                )
                if (cityStatus === 'complete') {
                  state.locationInfo.lat =
                    cityResult.position?.[1] || ''
                  state.locationInfo.lng =
                    cityResult.position?.[0] || ''
                  state.locationInfo.city =
                    cityResult.city || '广州市'
                  state.locationInfo.province =
                    cityResult.province || '广东省'
                  resolve({
                    status: true,
                    data: { ...cityResult },
                    message: '通过IP获取位置信息成功'
                  })
                } else {
                  console.warn('IP定位也失败，使用默认位置')
                  setDeafultLocal({ commit, state })
                  resolve({
                    status: true,
                    data: {},
                    message: '定位失败，使用默认位置'
                  })
                }
              }
            )
            return
          }

          // 情况2：定位成功，检查是否有经纬度信息
          const hasLatLng =
            result.position &&
            (result.position.lat || result.position[1]) &&
            (result.position.lng || result.position[0])

          if (hasLatLng) {
            const lng =
              result.position.lng || result.position[0]
            const lat =
              result.position.lat || result.position[1]
            state.locationInfo.lng = lng
            state.locationInfo.lat = lat

            const locationType = result.location_type
            console.log('location_type:', locationType)

            // 设置城市信息的公共方法
            const setCityInfo = (city, province) => {
              state.locationInfo.city =
                city || result.city || '广州市'
              state.locationInfo.province =
                province || result.province || '广东省'
            }

            const resolveSuccess = (data, message) => {
              resolve({ status: true, data, message })
            }

            // 情况2-1：location_type 为 'ipcity'，直接使用 result.city
            if (locationType === 'ipcity') {
              setCityInfo()
              resolveSuccess(
                result,
                '通过IP定位获取城市信息成功'
              )
              return
            }

            // 情况2-2：location_type 为 'html5'，调用逆地理编码获取城市信息
            if (locationType === 'html5') {
              try {
                const AMapSearchCity = await SearchCity().catch(
                  err => {
                    console.error(err, '初始化获取城市失败')
                    return null
                  }
                )

                if (!AMapSearchCity) {
                  setCityInfo()
                  resolveSuccess(
                    result,
                    '获取定位成功，城市信息获取失败'
                  )
                  return
                }

                AMapSearchCity.getAddress(
                  [lng, lat],
                  (addressStatus, addressResult) => {
                    if (
                      addressStatus === 'complete' &&
                      addressResult.info === 'OK'
                    ) {
                      const {
                        city,
                        province
                      } = addressResult.regeocode.addressComponent
                      setCityInfo(city, province)
                      resolveSuccess(
                        { ...addressResult },
                        'HTML5定位获取城市信息成功'
                      )
                    } else {
                      setCityInfo()
                      resolveSuccess(
                        result,
                        '获取定位成功，地址解析失败'
                      )
                    }
                  }
                )
              } catch (err) {
                console.error('获取城市信息失败:', err)
                setCityInfo()
                resolveSuccess(
                  result,
                  '获取定位成功，处理过程中出现异常'
                )
              }
              return
            }

            // 其他 location_type 情况
            setCityInfo()
            resolveSuccess(result, '获取定位成功')
          } else if (result.province) {
            // 情况3：无经纬度但有基础城市信息（province字段存在）
            state.locationInfo.city =
              result.city || '广州市'
            state.locationInfo.province = result.province
            // 如果有position数组，尝试获取经纬度
            if (
              result.position &&
              result.position.length >= 2
            ) {
              state.locationInfo.lng =
                result.position[0] || ''
              state.locationInfo.lat =
                result.position[1] || ''
            }
            resolve({
              status: true,
              data: result,
              message: '获取基础定位信息成功'
            })
          } else {
            // 其他情况：使用默认位置
            console.warn('定位信息不完整，使用默认位置')
            setDeafultLocal({ commit, state })
            resolve({
              status: true,
              data: {},
              message: '定位信息不完整，使用默认位置'
            })
          }
        }
      )

      // 尝试获取位置
      // const locationPromise = new Promise(
      //   (resolve, reject) => {
      //     AMapLocation.getCurrentPosition(
      //       async (status, result) => {
      //         console.log(
      //           status,
      //           result,
      //           '定位结果getCurrentPosition'
      //         )

      //         if (
      //           status?.info &&
      //           status?.info === 'SUCCESS'
      //         ) {
      //           state.locationInfo.lng = result.position.lng
      //           state.locationInfo.lat = result.position.lat

      //           try {
      //             const AMapSearchCity = await SearchCity().catch(
      //               err => {
      //                 console.error(
      //                   err,
      //                   '初始化获取城市失败'
      //                 )
      //                 // 即使城市获取失败，也使用定位的经纬度
      //                 resolve({
      //                   status: true,
      //                   data: result,
      //                   message:
      //                     '获取定位成功，城市信息获取失败'
      //                 })
      //                 return null
      //               }
      //             )

      //             if (!AMapSearchCity) return

      //             const lnglat = [
      //               result.position.lng,
      //               result.position.lat
      //             ]

      //             AMapSearchCity.getAddress(
      //               lnglat,
      //               (addressStatus, addressResult) => {
      //                 if (
      //                   addressStatus === 'complete' &&
      //                   addressResult.info === 'OK'
      //                 ) {
      //                   state.locationInfo.city =
      //                     addressResult.regeocode
      //                       .addressComponent.city ||
      //                     '未知城市'
      //                   state.locationInfo.province =
      //                     addressResult.regeocode
      //                       .addressComponent.province ||
      //                     '未知省份'
      //                   resolve({
      //                     status: true,
      //                     data: {
      //                       ...addressResult
      //                     },
      //                     message: '获取定位成功'
      //                   })
      //                 } else {
      //                   // 地址解析失败时仍然使用经纬度
      //                   resolve({
      //                     status: true,
      //                     data: result,
      //                     message:
      //                       '获取定位成功，地址解析失败'
      //                   })
      //                 }
      //               }
      //             )
      //           } catch (err) {
      //             console.error('获取城市信息失败:', err)
      //             // 出现异常时仍然返回定位结果
      //             resolve({
      //               status: true,
      //               data: result,
      //               message:
      //                 '获取定位成功，处理过程中出现异常'
      //             })
      //           }
      //         } else {
      //           // 定位失败时尝试通过IP获取城市信息
      //           AMapLocation.getCityInfo(
      //             (status, result) =>AMapLocation.getCityInfo {
      //               console.log(
      //                 status,
      //                 result,
      //                 'getCityInfo'
      //               )
      //               if (status === 'complete') {
      //                 state.locationInfo.lat =
      //                   result.position[1] || ''
      //                 state.locationInfo.lng =
      //                   result.position[0] || ''
      //                 state.locationInfo.city =
      //                   result.city || '广州市'
      //                 state.locationInfo.province =
      //                   result.province || '广东省'
      //                 resolve({
      //                   status: true,
      //                   data: {
      //                     ...result
      //                   },
      //                   message: '通过IP获取位置信息成功'
      //                 })
      //               } else {
      //                 console.error(
      //                   `状态: ${status} \n 结果:${result}`,
      //                   '定位失败'
      //                 )

      //                 // 设置默认地址
      //                 setDeafultLocal({ commit, state })
      //                 resolve({
      //                   status: true,
      //                   data: {},
      //                   message: '定位失败，使用默认位置'
      //                 })
      //               }
      //             }
      //           )
      //         }
      //       }
      //     )
      //   }
      // )

      // 等待定位完成或超时
      // Promise.race([locationPromise, timeoutPromise]).catch(
      //   err => {
      //     console.error('定位过程异常:', err)
      //     setDeafultLocal({ commit, state })
      //     resolve({
      //       status: true,
      //       data: {},
      //       message: '定位过程异常，使用默认位置'
      //     })
      //   }
      // )
    } catch (err) {
      console.error('定位服务异常:', err)
      setDeafultLocal({ commit, state })
      resolve({
        status: true,
        data: {},
        message: '定位服务异常，使用默认位置'
      })
    }
  })
}

const setCity = ({ commit, state }, cityName) => {
  return new Promise(async (resolve, reject) => {
    try {
      const AMapSearchCity = await SearchCity()

      await AMapSearchCity.getLocation(cityName, function(
        status,
        result
      ) {
        console.log(status, result, '定位结果')

        if (
          status === 'complete' &&
          result.geocodes.length
        ) {
          const {
            location,
            addressComponent
          } = result.geocodes[0]

          state.locationInfo.lng = location.lng
          state.locationInfo.lat = location.lat
          state.locationInfo.city = addressComponent.city
          state.locationInfo.province =
            addressComponent.province

          resolve({
            status: true,
            data: result,
            message: '定设置城市成功'
          })
        } else {
          // Taost('设置城市失败')
          resolve({
            status: false,
            message: '设置城市失败'
          })
        }
      })
    } catch (err) {
      console.error('SearchCity失败', err)
    }
  })
  // AMapSearchCity.CitySearchCallback(
  //   ({ ip: '北京' }, result) => {
  //   }
  // )
}

const state = {
  locationInfo: {
    accuracy: '',
    adcode: '',
    addr: '',
    city: '',
    district: '',
    lat: '',
    lng: '',
    module: '',
    nation: '',
    province: '',
    type: '',
    id: ''
  }
}

const mutations = {}

const actions = {
  getLocation,
  setCity
  // async getLocation({ commit, state }) {

  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
